import { alpha, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: theme.spacing(1, 4),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 4),
      justifyContent: 'flex-end',
    },
  },
  appBarToggle: {
    zIndex: theme.zIndex.appBar,
  },
  appBar: (props) => ({
    backgroundImage: `linear-gradient(to top, transparent 50%, ${theme.palette.background.header} 50%)`,
    backgroundSize: '100% 200%',
    transition:
      'background-position 0.25s ease-in-out, color 0.25s ease-in-out',
    backgroundPosition: props.trigger ? 'top' : 'bottom',
    backdropFilter: 'blur(60px)',
  }),
  hideElement: { display: 'none' },
  hamburgerWrapper: {
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      width: '100%',
      height: '3px',
      display: 'block',
      background: theme.palette.secondary.main,
      position: 'absolute',
      opacity: 1,
      transition: 'top, transform .35s cubic-bezier(.23,1,.32,1)',
    },
    '&:before': {
      top: '4px',
    },
    '&:after': {
      top: '20px',
    },
  },
  rotateIcon: {
    '&:before': {
      transform: 'rotate(45deg)',
      top: '13px',
    },
    '&:after': {
      transform: 'rotate(-45deg)',
      top: '13px',
    },
  },
  hamburgerIcon: (props) => ({
    width: '100%',
    height: '3px',
    display: props.drawerToggle ? 'none' : 'block',
    backgroundColor: theme.palette.secondary.main,
    position: 'absolute',
    top: '12px',
    opacity: 1,
  }),
  toolbarOffset: {
    height: 'inherit',
    [theme.breakpoints.up('md')]: {
      height: 100,
    },
  },
  navigation: {
    display: 'flex',
    alignItems: 'center',
    '&>*': {
      margin: theme.spacing(0, 2),
      '[lang=ar] &': {
        lineHeight: 2,
      },
    },
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      flex: 1,
      overflow: 'auto',
      '&>*': {
        margin: theme.spacing(1, 0),
      },
    },
  },
  navigationDrawer: {
    '& .MuiDrawer-paper': {
      width: '100%',
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      padding: theme.spacing(3, 4),
    },
    '& $toolbar': {
      borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    },
    '& svg': {
      color: theme.palette.text.primary,
    },
    '& $headerText': {
      color: theme.palette.text.primary,
    },
  },
  headerText: {
    fontSize: '1.125rem',
    fontWeight: 500,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.75rem',
      fontWeight: 700,
    },
    '[lang=ar] &': {
      fontWeight: 'bold',
    },
  },
  headerLanguageLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'inline-block',
    padding: theme.spacing(0, 1),
  },
  languageSwitcher: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(4),
    '[lang=ar] &': {
      marginLeft: theme.spacing(3),
    },
    '& > .headerLanguageLink': {
      minWidth: theme.spacing(4.5),
      '[lang=ar] &:not($inactiveLanguage)': {
        paddingBottom: theme.spacing(1.25),
      },
    },
    '[lang=en] & $inactiveLanguage': {
      fontFamily: 'SSTArabic, Arial',
      position: 'relative',
      top: '-8px',
      fontWeight: 700,
    },
    '[lang=ar] & $inactiveLanguage': {
      [theme.breakpoints.down('sm')]: {
        top: '3px',
        position: 'relative',
      },
    },
    '[lang=ar] & :not($inactiveLanguage)': {
      top: '-3px',
      position: 'relative',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 'auto',
      '& $headerText': {
        fontWeight: 'normal',
        textTransform: 'uppercase',
        fontSize: '1.375rem',
      },
    },
  },
  inactiveLanguage: {
    color: theme.palette.grey[500],
    position: 'relative',
    '&:before': {
      position: 'absolute',
      width: 2,
      height: '1.125rem',
      backgroundColor: theme.palette.secondary.main,
      content: "' '",
    },
    '[lang=en] &:before': {
      [theme.breakpoints.down('sm')]: {
        left: '1px',
        backgroundColor: theme.palette.text.secondary,
        top: '16px',
      },
      left: 0,
      top: '12px',
    },
    '[lang=ar] &:before': {
      [theme.breakpoints.down('sm')]: {
        top: theme.spacing(2.5),
        backgroundColor: theme.palette.text.secondary,
        right: -4,
      },

      top: theme.spacing(1.75),
      right: -2,
    },
  },
  squareButton: {
    borderRadius: 2,
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  mobileButton: {
    width: '100%',
  },
  primaryButton: {
    borderRadius: 2,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      padding: theme.spacing(0.5, 1.5),
    },
    '&:after': {
      content: '""',
      opacity: 0.4,
    },
  },

  link: {
    color: 'inherit',
    position: 'relative',
    boxSizing: 'content-box',
  },
  menuItem: {
    display: 'inline-block',
    '&:after': {
      display: 'block',
      content: '""',
      borderBottom: `solid 2px ${theme.palette.primary.main}`,
      transform: 'scaleX(0)',
      position: 'relative',
      top: '2px',
      transition: 'transform 250ms ease-in-out',
    },
    '&:hover:after': {
      transform: 'scaleX(1)',
    },
  },
  logo: {
    color: theme.palette.secondary.main,
    marginRight: 'auto',
    lineHeight: 0,
    '& > svg': {
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(7),
      },
      [theme.breakpoints.up('md')]: {
        width: theme.spacing(10),
      },
    },
  },
}))
